import React from 'react';
// Bootstrap Imports
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import FormControl from 'react-bootstrap/FormControl';
// Axios Imports
import AxiosConfig from '../../utilities/AxiosConfig';
import { qsStringify } from '../../utilities/helper';
import Dialog from '../../utilities/Dialog';
import axios from 'axios';
// Other Imports
import { AllowedRoleType } from './AllowedRoles';
import logger from '../../utilities/logging';

export interface AllowedRoleRowProps {
    role : {roleName : string, target : string, key : number, description: string | null},
    deleteCB : () => void,
    editCB : (index: number, edits: AllowedRoleType) => void,
    index : number
}

const AllowedRoleRow: React.FunctionComponent<AllowedRoleRowProps> = (props: AllowedRoleRowProps) => {
    const [editing, setEditing] = React.useState(false);
    const [edits, setEdits] = React.useState({...props.role});
    const [sendingEdits, setSendingEdits] = React.useState(false);
    const { roleName, target } = props.role;
    const { deleteCB, editCB, index } = props;

    const deleteAllowedRole = async(e: React.SyntheticEvent) => {
        e.preventDefault();
        let c: any = new Dialog({ message: `Are you sure you want to delete ${roleName} allowed role?` });
        let answer: boolean = await c.show();
        if(answer){
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            myHeaders.append("authorization", AxiosConfig.configValue().headers.authorization);

            var urlencoded = new URLSearchParams();
            urlencoded.append("roleName", roleName);
            urlencoded.append("target", target);

            var requestOptions = {
                method: 'DELETE',
                headers: myHeaders,
                body: urlencoded,
            };

            fetch(process.env.REACT_APP_API_URL + "/api/portal/allowedrole", requestOptions)
            .then(response => response.text())
            .then(result => {
                if(result){
                    deleteCB();
                }else{
                    logger.Error({
                        EventMessage : `AllowedRoleRow -> Error Deleting Allowed Role --> No Result --> Result : ${result}`,
                        EventCategory : "httprequest",
                    })
                    alert("Failed to delete role.");
                }
            })
            .catch(error => {
                //console.log(error);
                AxiosConfig.handleError(error);
                logger.Error({
                    EventMessage : `AllowedRoleRow -> Error Deleting Allowed Role --> Error :  ${JSON.stringify(error)}`,
                    EventCategory : "httprequest",
                })
            });
        }
    }

    const toggleEdit = (e: React.SyntheticEvent) => {
        e.preventDefault();
        setEditing(!editing);
    }

    const handleEditsChange = (e: React.ChangeEvent<HTMLInputElement>):void => {
        e.preventDefault();
        setEdits({...edits, [e.target.name] : e.target.value});
    } 

    const handleEditSubmit = (e: React.SyntheticEvent) => {
        e.preventDefault();
        setSendingEdits(true);
        const config = AxiosConfig.configValue();
        const requestBody = qsStringify({...props.role, ...edits});
        axios.patch(process.env.REACT_APP_API_URL + '/api/portal/allowedrole', requestBody, config)
        .then(res => {
            setEditing(false);
            setEdits(props.role);
            editCB(index, edits);
        })
        .catch(err => {
            //console.log(err, err.response);
            logger.Error({
                EventMessage : `AllowedRoleRow -> handleEditSubmit --> Error :  ${JSON.stringify(err)}`,
                EventCategory : "httprequest",
            });
            AxiosConfig.handleError(err);
        })
        .finally(() => {
            setSendingEdits(false);
        })
    }

    return (
        <tr>
            <td>
                {roleName}
            </td>
            <td>
                {
                    editing
                    ?<FormControl onChange={handleEditsChange} name="target" type="text" value={edits.target} />
                    :target
                }
            </td>
            <td>
                <ButtonGroup className="d-flex flex-row justify-content-end">
                {
                    editing
                        ?
                        <>
                        <Button className="flex-0" onClick={handleEditSubmit} disabled={sendingEdits}>
                            {
                                sendingEdits
                                ?<Spinner size="sm" role="status" as="span" animation="border" />
                                :<i className="material-icons">save</i>
                            }
                        </Button>
                        <Button className="flex-0" onClick={toggleEdit} variant="danger">
                            <i className="material-icons">cancel</i>
                        </Button>
                        </>
                        :
                        <>
                        <Button className="flex-0" onClick={toggleEdit}>
                            <i className="material-icons">edit</i>
                        </Button>
                        <Button className="flex-0" onClick={deleteAllowedRole} variant="danger">
                            <i className="material-icons">delete</i>
                        </Button>
                        </>
                    }
                    </ButtonGroup>
            </td>
        </tr>
    );
}

export default AllowedRoleRow;